<template>
    <rkm-area
        no-margin-top
        title="Intervenções e/ou procedimentos clínicos"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.procedimentos"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="8">
                                <Item
                                    :get-value="() => `${formatProcedimento(item.procedimento.codigo)} - ${item.procedimento.nome}`"
                                    label="Procedimento"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.quantidade"
                                    label="Quantidade"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.automatico ? 'Sim' : 'Não'"
                                    label="Automático"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="8">
                                <Item
                                    :get-value="() => item.materialDescricaoCompleta"
                                    label="Material"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => item.materialQuantidade"
                                    label="Quantidade do material"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.localCurativo"
                                    label="Local do curativo"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>